import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '../config';
import { AppSettings, DayAvailability } from '@/model/availability.model';

@Injectable({ providedIn: 'root' })
export class AvailabilityService {
  constructor(private http: HttpClient) {}

  // وضعیت (خالی/رزروشده/غیرفعال) و قیمت همه‌ی بازه‌های یک روز کاری - بدون اطلاعات مشتری
  // holdToken: نگه‌داشت خود مشتری برای او «خالی» برگردانده می‌شود
  // forPanel: نمای پنل؛ غیرفعال‌سازی‌های «فقط آنلاین» برای ثبت حضوری اعمال نمی‌شوند
  getDay(date: string, roomId?: number, holdToken?: string, forPanel = false): Observable<DayAvailability> {
    const params: Record<string, string> = { date };
    if (forPanel) params['channel'] = 'panel';
    if (roomId) params['roomId'] = String(roomId);
    if (holdToken) params['holdToken'] = holdToken;
    return this.http.get<DayAvailability>(`${config.apiUrl}/availability`, { params });
  }

  getSettings(): Observable<AppSettings> {
    return this.http.get<AppSettings>(`${config.apiUrl}/settings`);
  }

  updateSettings(payload: Partial<AppSettings>): Observable<AppSettings> {
    return this.http.patch<AppSettings>(`${config.apiUrl}/settings`, payload);
  }

  uploadLogo(file: File): Observable<AppSettings> {
    const form = new FormData();
    form.append('logo', file);
    return this.http.post<AppSettings>(`${config.apiUrl}/settings/logo`, form);
  }
}
